<ng-container *ngIf="objectCustomFields?.definitions?.length">
  <div class="details-row" *ngFor="let customField of objectCustomFields?.definitions">
    <span class="details-label">{{ getLabel(customField) }}</span>

    <span class="details-value" [ngSwitch]="customField.field_type">
      <!-- single/multi select => badges/tags -->
      <ng-container *ngSwitchCase="customFieldTypes.SINGLE_SELECT">
        <ng-container *ngIf="getSelectValues(customField) as vals">
          <ng-container *ngIf="vals.length; else emptyValue">
            <span class="details-badge-container">
              <span class="details-badge" *ngFor="let v of vals">{{ v }}</span>
            </span>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="customFieldTypes.MULTI_SELECT">
        <ng-container *ngIf="getSelectValues(customField) as vals">
          <ng-container *ngIf="vals.length; else emptyValue">
            <span class="details-badge-container">
              <span class="details-badge" *ngFor="let v of vals">{{ v }}</span>
            </span>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- email/url => blue link -->
      <ng-container *ngSwitchCase="customFieldTypes.EMAIL">
        <ng-container *ngIf="getHref(customField); else emptyValue">
          <a [href]="getHref(customField)">{{ getValue(customField) }}</a>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="customFieldTypes.URL">
        <ng-container *ngIf="getHref(customField); else emptyValue">
          <a [href]="getHref(customField)" target="_blank" rel="noopener">
            {{ getValue(customField) }}
          </a>
        </ng-container>
      </ng-container>

      <!-- boolean => yes/no -->
      <ng-container *ngSwitchCase="customFieldTypes.BOOLEAN">
        <ng-container *ngIf="hasValue(customField); else emptyValue">
          {{ getTextValue(customField) | translate }}
        </ng-container>
      </ng-container>

      <!-- default => text -->
      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="hasValue(customField) && getTextValue(customField) !== emptyValuePlaceholder; else emptyValue">
          {{ getTextValue(customField) }}
        </ng-container>
      </ng-container>
    </span>

    <ng-template #emptyValue>{{ emptyValuePlaceholder }}</ng-template>
  </div>
</ng-container>

